<template>
    <div class="pod-search-container">
        <!-- Search History Section -->
        <div class="search-history" v-if="searchHistory.length > 0">
                    <div class="history-header" @click="toggleHistory">
                        <div class="history-title">
                            <i class="fa" :class="showHistory ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                    <span>Your Recent Searches</span>
                            <span class="history-count">({{ filteredHistory.length }})</span>
                        </div>
                        <div class="history-actions">
                    <input 
                        type="text" 
                                       v-model="historyFilter" 
                                       placeholder="Filter history..."
                                       @click.stop
                        class="history-filter-input"
                    >
                    <button type="button" class="clear-history-btn" @click.stop="clearHistory">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </div>
            
                    <div class="history-content" v-show="showHistory">
                        <div class="history-list">
                    <div 
                        v-for="(item, index) in filteredHistory" 
                                 :key="index" 
                                 class="history-item"
                        :class="{'pinned': item.pinned}"
                    >
                                <div class="history-item-content" @click="loadHistoryItem(item)">
                                    <div class="history-item-header">
                                        <div class="history-item-title">
                                    <button 
                                        type="button" 
                                        class="pin-btn" 
                                                    @click.stop="togglePin(index)"
                                        :class="{'pinned': item.pinned}"
                                    >
                                                <i class="fa" :class="item.pinned ? 'fa-star' : 'fa-star-o'"></i>
                                            </button>
                                    <span class="history-podcast">{{ getHistoryItemPodcastTitle(item) }}</span>
                                        </div>
                                        <div class="history-meta">
                                    <span class="history-type">{{ formatSearchType(item.searchLevel) }} - {{ formatSearchType(item.searchType) }}</span>
                                            <span class="history-hits" v-if="item.hitCount !== undefined">
                                                <i class="fa fa-search"></i>
                                                {{ formatHitCount(item.hitCount) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="history-item-details">
                                        <span class="history-keywords">{{ item.keywords }}</span>
                                        <span class="history-date-filter" v-if="item.dateFilterMode && item.dateFilterMode !== 'none'">
                                            <i class="fa fa-calendar"></i>
                                            {{ formatDateFilter(item) }}
                                        </span>
                                        <span class="history-time">{{ formatTime(item.timestamp) }}</span>
                                    </div>
                                </div>
                        <button 
                            type="button" 
                            class="remove-history-btn" 
                            @click.stop="removeHistoryItem(index)"
                        >
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

        <!-- Main Search Form -->
        <form @submit.prevent="performSearch" class="search-form">
            <!-- Search Level Tabs -->
            <div class="search-tabs">
                <button 
                    type="button"
                    class="tab-btn"
                    :class="{'active': searchLevel === 'single'}"
                    @click="setSearchLevel('single')"
                >
                    Single Podcast
                </button>
                <button 
                    type="button"
                    class="tab-btn"
                    :class="{'active': searchLevel === 'multiple'}"
                    @click="setSearchLevel('multiple')"
                >
                    Multiple/All Podcasts
                </button>
                        </div>

            <!-- Search Description -->
            <div class="search-description">
                <p>{{ getSearchDescription() }}</p>
                        </div>

            <!-- Search Mode Selection (for Multiple/All) -->
            <div class="search-mode" v-if="searchLevel === 'multiple'">
                <div class="mode-options">
                    <label class="mode-option">
                        <input 
                            type="radio" 
                            v-model="searchMode" 
                            value="all"
                            name="searchMode"
                        >
                        <span class="mode-label">Search All Podcasts</span>
                    </label>
                    <label class="mode-option">
                        <input 
                            type="radio" 
                            v-model="searchMode" 
                            value="multiple"
                            name="searchMode"
                        >
                        <span class="mode-label">Select Specific Podcasts</span>
                    </label>
                    <label class="mode-option">
                        <input 
                            type="radio" 
                            v-model="searchMode" 
                            value="category"
                            name="searchMode"
                        >
                        <span class="mode-label">Search by Category</span>
                    </label>
                                </div>
                            </div>

            <!-- Podcast Selection -->
            <div class="podcast-selection" v-if="searchLevel === 'single' || (searchLevel === 'multiple' && searchMode === 'multiple')">
                <div class="selection-header">
                    <label class="selection-label">
                        {{ searchLevel === 'single' ? 'Select Podcast' : 'Select Podcasts' }}
                                        </label>
                    <button 
                        type="button" 
                        class="clear-selection-btn" 
                        @click="clearPodcastSelection"
                        v-if="selectedPodcasts && selectedPodcasts.length > 0"
                    >
                        Clear Selection
                    </button>
                                    </div>
                
                <v-select
                    v-model="selectedPodcasts"
                    :options="availablePodcasts"
                    :multiple="searchLevel === 'multiple'"
                    :searchable="true"
                    :close-on-select="searchLevel === 'single'"
                    :clearable="true"
                    placeholder="Search and select podcasts..."
                    label="podcast_title"
                    track-by="id"
                    class="podcast-select"
                />
                                </div>

            <!-- Category Selection -->
            <div class="category-selection" v-if="searchLevel === 'multiple' && searchMode === 'category'">
                <div class="selection-header">
                    <label class="selection-label">Select Category</label>
                    <button 
                        type="button" 
                        class="clear-selection-btn" 
                        @click="clearCategorySelection"
                        v-if="selectedCategory && selectedCategory.length > 0"
                    >
                        Clear Selection
                    </button>
                            </div>
                
                <v-select
                    v-model="selectedCategory"
                    :options="availableCategories"
                    :multiple="true"
                    :searchable="true"
                    :close-on-select="false"
                    :clearable="true"
                    placeholder="Search and select categories..."
                    label="label"
                    track-by="podcast_category"
                    class="category-select"
                />
                            </div>

            <!-- Search Type Selection -->
            <div class="search-type">
                <div class="type-options">
                    <label class="type-option">
                        <input 
                            type="radio" 
                            v-model="searchType" 
                            value="basic"
                            name="searchType"
                        >
                        <span class="type-label">Basic Search</span>
                    </label>
                    <label class="type-option">
                        <input 
                            type="radio" 
                            v-model="searchType" 
                            value="advanced"
                            name="searchType"
                        >
                        <span class="type-label">Advanced Search</span>
                    </label>
                    <label class="type-option">
                        <input 
                            type="radio" 
                            v-model="searchType" 
                            value="episode"
                            name="searchType"
                        >
                        <span class="type-label">Episode Title Search</span>
                                    </label>
                                </div>
                            </div>


            <!-- Keywords Input -->
            <div class="keywords-section">
                <div class="keywords-header">
                    <label class="keywords-label">
                        {{ getKeywordsLabel() }}
                    </label>
                    <label class="exact-match-option" v-if="searchType === 'basic' || searchType === 'episode'">
                        <input 
                            type="checkbox" 
                            v-model="exactMatch"
                        >
                        <span class="exact-match-label">Exact Match</span>
                    </label>
                                </div>

                <!-- Basic/Episode Search -->
                <div v-if="searchType === 'basic' || searchType === 'episode'" class="basic-keywords">
                    <input 
                        type="text" 
                        v-model="keywords"
                        :placeholder="getKeywordsPlaceholder()"
                        :disabled="!canEnterKeywords()"
                        class="keywords-input"
                    >
                    <button 
                        type="button" 
                        class="clear-keywords-btn" 
                        @click="clearKeywords"
                        v-if="keywords"
                    >
                        <i class="fa fa-times"></i>
                    </button>
                            </div>

                <!-- Advanced Search -->
                <div v-else-if="searchType === 'advanced'" class="advanced-keywords">
                    <div 
                        v-for="(term, index) in advancedTerms" 
                        :key="index"
                        class="advanced-term"
                    >
                        <input 
                            type="text" 
                            v-model="term.value"
                            :placeholder="`Keyword ${index + 1}`"
                            :disabled="!canEnterKeywords()"
                            class="advanced-input"
                        >
                        <button 
                            type="button" 
                            class="remove-term-btn" 
                            @click="removeAdvancedTerm(index)"
                            v-if="advancedTerms.length > 1"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                    <button 
                        type="button" 
                        class="add-term-btn" 
                        @click="addAdvancedTerm"
                        :disabled="advancedTerms.length >= 6"
                    >
                        <i class="fa fa-plus"></i> Add Keyword
                    </button>
                </div>
                </div>
                
            <!-- Date Filter Section -->
            <div class="date-filter-section">
                <div class="date-filter-header">
                    <label class="date-filter-label">Date Filter (Optional)</label>
                    <button 
                        type="button" 
                        class="clear-date-btn" 
                        @click="clearDateFilter"
                        v-if="dateFilterMode !== 'none'"
                    >
                        Clear Date Filter
                    </button>
                </div>
                
                <div class="date-filter-mode">
                    <label class="date-mode-option">
                        <input 
                            type="radio" 
                            v-model="dateFilterMode" 
                            value="none"
                            name="dateFilterMode"
                        >
                        <span class="date-mode-label">No Date Filter</span>
                    </label>
                    <label class="date-mode-option">
                        <input 
                            type="radio" 
                            v-model="dateFilterMode" 
                            value="before"
                            name="dateFilterMode"
                        >
                        <span class="date-mode-label">Before</span>
                    </label>
                    <label class="date-mode-option">
                        <input 
                            type="radio" 
                            v-model="dateFilterMode" 
                            value="after"
                            name="dateFilterMode"
                        >
                        <span class="date-mode-label">After</span>
                    </label>
                    <label class="date-mode-option">
                        <input 
                            type="radio" 
                            v-model="dateFilterMode" 
                            value="between"
                            name="dateFilterMode"
                        >
                        <span class="date-mode-label">Between</span>
                    </label>
                </div>
                
                <div class="date-inputs" v-if="dateFilterMode !== 'none'">
                    <div class="date-input-group" v-if="dateFilterMode === 'before' || dateFilterMode === 'after'">
                        <label class="date-input-label">
                            {{ dateFilterMode === 'before' ? 'Before Date' : 'After Date' }}
                        </label>
                        <input 
                            type="date" 
                            v-model="dateFilterSingle"
                            class="date-input"
                        >
                    </div>
                    
                    <div class="date-input-group" v-if="dateFilterMode === 'between'">
                        <div class="date-range-inputs">
                            <div class="date-input-wrapper">
                                <label class="date-input-label">Start Date</label>
                                <input 
                                    type="date" 
                                    v-model="dateFilterStart"
                                    class="date-input"
                                >
                            </div>
                            <div class="date-input-wrapper">
                                <label class="date-input-label">End Date</label>
                                <input 
                                    type="date" 
                                    v-model="dateFilterEnd"
                                    class="date-input"
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Search Button -->
            <div class="search-actions">
                <button 
                    type="submit" 
                    class="search-btn"
                    :class="{'disabled': !canSearch()}"
                    :disabled="!canSearch() || isSearching"
                >
                    <span v-if="isSearching">
                        <i class="fa fa-spinner fa-spin"></i> Searching...
                    </span>
                    <span v-else>Search</span>
                </button>
            </div>
        </form>

        <!-- Error Message -->
        <div v-if="errorMessage" class="error-message">
            <i class="fa fa-exclamation-circle"></i>
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'PodSearch',
    props: {
        searchedKeywords: String,
        podId: [String, Number],
        userRole: String,
        pods: String,
        epCount: [String, Number],
        categories: {
            type: String,
            default: '[]'
        }
    },
    
    data() {
        return {
            // Search Configuration
            searchLevel: 'single', // 'single', 'multiple', 'all'
            searchMode: 'all', // 'all', 'multiple', 'category' (for multiple/all levels)
            searchType: 'basic', // 'basic', 'advanced', 'episode'
            exactMatch: true,
            
            // Podcast Selection
            selectedPodcasts: [],
            selectedCategory: [],
            
            // Keywords
            keywords: '',
            advancedTerms: [
                { value: '' },
                { value: '' }
            ],
            
            // Date Filter
            dateFilterMode: 'none', // 'none', 'before', 'after', 'between'
            dateFilterSingle: '',
            dateFilterStart: '',
            dateFilterEnd: '',
            
            // UI State
            isSearching: false,
            errorMessage: '',
            showHistory: false,
            historyFilter: '',
            
            // Search History
            searchHistory: [],
            maxHistoryItems: 10,
            
            // Internal state
            _urlStateLoaded: false
        };
    },
    
    computed: {
        availablePodcasts() {
            try {
                return JSON.parse(this.pods || '[]');
            } catch (e) {
                console.error('Error parsing podcasts:', e);
                return [];
            }
        },
        
        availableCategories() {
            try {
                const categories = JSON.parse(this.categories || '[]');
                return categories.map(category => ({
                    ...category,
                    label: `${category.podcast_category} (${category.count})`
                }));
            } catch (e) {
                console.error('Error parsing categories:', e);
                return [];
            }
        },
        
        episodeCount() {
            return Number(this.epCount) || 0;
        },
        
        filteredHistory() {
            if (!this.historyFilter) {
                return this.searchHistory;
            }
            
            const filter = this.historyFilter.toLowerCase();
            return this.searchHistory.filter(item => {
                return (
                    (item.podcastTitle && item.podcastTitle.toLowerCase().includes(filter)) ||
                    (item.keywords && item.keywords.toLowerCase().includes(filter)) ||
                    (item.searchType && item.searchType.toLowerCase().includes(filter))
                );
            });
        },
        

    },
    
    watch: {
        searchLevel(newLevel) {
            // Don't reset state if we're loading from URL
            if (!this._urlStateLoaded) {
                this.resetSearchState();
                // Only set default searchMode when not loading from URL
                this.searchMode = newLevel === 'multiple' ? 'all' : 'all';
            }
        },
        
        searchMode(newMode) {
            if (newMode === 'all') {
                this.selectedPodcasts = [];
                this.selectedCategory = [];
            } else if (newMode === 'category') {
                this.selectedPodcasts = [];
            }
        },
        
        availablePodcasts: {
            handler(newPodcasts) {
                if (newPodcasts && newPodcasts.length > 0) {
                    // Load URL state after podcasts are available
                    this.loadSearchStateFromUrl();
            }
            },
            immediate: true
        },
        

    },
    
    mounted() {
        this.loadSearchHistory();
        this.initializeFromProps();
        this.updateHitCounts();
    },
    
    methods: {
        // Search Level Management
        setSearchLevel(level) {
            
            this.searchLevel = level;
        },
        
        resetSearchState() {
            this.selectedPodcasts = [];
            this.selectedCategory = [];
            this.keywords = '';
            this.advancedTerms = [
                { value: '' },
                { value: '' }
            ];
            this.exactMatch = false;
            this.searchType = 'basic';
            this.dateFilterMode = 'none';
            this.dateFilterSingle = '';
            this.dateFilterStart = '';
            this.dateFilterEnd = '';
        },
        
        // Validation Methods
        canSearch() {
            if (!this.canEnterKeywords()) return false;
            
            if (this.searchType === 'basic' || this.searchType === 'episode') {
                return this.keywords.trim().length > 0;
            } else if (this.searchType === 'advanced') {
                return this.advancedTerms.some(term => term.value.trim().length > 0);
                }
            
            return false;
        },
        
        canEnterKeywords() {
            if (this.searchLevel === 'multiple' && this.searchMode === 'all') return true;
            if (this.searchLevel === 'multiple' && this.searchMode === 'multiple') {
                return this.selectedPodcasts && this.selectedPodcasts.length > 0;
            }
            if (this.searchLevel === 'multiple' && this.searchMode === 'category') {
                return this.selectedCategory && this.selectedCategory.length > 0;
            }
            if (this.searchLevel === 'single') {
                return this.selectedPodcasts && (Array.isArray(this.selectedPodcasts) ? this.selectedPodcasts.length > 0 : !!this.selectedPodcasts);
            }
                return false;
        },
        
        // canUseBasicSearch() {
        //     return this.userRole === 'paidbasicmember' || this.userRole === 'admin' || this.userRole === 'paidmember';
        // },
        canUseAdvancedSearch() {
            return this.userRole === 'paidbasicmember' || this.userRole === 'admin';
        },
        
        // Search Execution
        async performSearch() {
            if (!this.canSearch()) return;
            
            this.isSearching = true;
            this.errorMessage = '';

            try {
                this.saveSearchHistory();
                await this.executeSearch();
            } catch (error) {
                this.handleSearchError(error);
            } finally {
                this.isSearching = false;
            }
        },

        async executeSearch() {
            const searchParams = this.buildSearchParams();
            const url = this.buildSearchUrl(searchParams);
            
            // Verify endpoint accessibility
            // try {
            //     await axios.head(url);
            //     //console.log(url);
            //     window.location.href = url;
            // } catch (error) {
            //     throw new Error('Search endpoint not accessible');
            // }

            window.location.href = url;
        },

        buildSearchParams() {
            const params = {
                search_type: this.searchType,
                keywordsToSearch: this.searchType === 'advanced' ? '' : this.keywords,
                exact_match: this.exactMatch,
                slv: this.searchLevel
            };
            
            // Add search mode for multiple/all searches
            if (this.searchLevel === 'multiple') {
                params.searchMode = this.searchMode;
                // if (window.location.search.includes('per_page')) {
                //     params.per_page = window.location.search.split('per_page=')[1];
                // } else {
                //     params.per_page = 20;
                // }
                params.per_page = 20;
            }
            // Add podcast selection
            if (this.searchLevel === 'single') {
                // Handle both single object and array cases
                if (Array.isArray(this.selectedPodcasts)) {
                    params.podSelectedId = this.selectedPodcasts[0]?.id;
                } else {
                    params.podSelectedId = this.selectedPodcasts?.id;
                }
            } else if (this.searchLevel === 'multiple' && this.searchMode === 'multiple') {
                // Ensure we have an array for multiple selection
                const podcastsArray = Array.isArray(this.selectedPodcasts) ? this.selectedPodcasts : [];
                params.podSelectedId = podcastsArray.map(p => p.id).join(',');
            } else if (this.searchLevel === 'multiple' && this.searchMode === 'category') {
                // Add category parameter
                if (this.selectedCategory && this.selectedCategory.length > 0) {
                    params.category = this.selectedCategory.map(c => c.podcast_category || c).join(',');
            }
            }
            
            // Add advanced search terms
            if (this.searchType === 'advanced') {
                const terms = this.advancedTerms
                    .filter(term => term.value.trim())
                    .map(term => term.value);
                params.search_terms = terms;
            }
            
            // Add date filter parameters
            if (this.dateFilterMode !== 'none') {
                if (this.dateFilterMode === 'before' && this.dateFilterSingle) {
                    params.date_filter = 'before';
                    params.date_value = this.dateFilterSingle;
                } else if (this.dateFilterMode === 'after' && this.dateFilterSingle) {
                    params.date_filter = 'after';
                    params.date_value = this.dateFilterSingle;
                } else if (this.dateFilterMode === 'between') {
                    if (this.dateFilterStart && this.dateFilterEnd) {
                        params.date_filter = 'between';
                        params.date_start = this.dateFilterStart;
                        params.date_end = this.dateFilterEnd;
                    } else if (this.dateFilterStart) {
                        // If only start date is provided, treat as "after"
                        params.date_filter = 'after';
                        params.date_value = this.dateFilterStart;
                    } else if (this.dateFilterEnd) {
                        // If only end date is provided, treat as "before"
                        params.date_filter = 'before';
                        params.date_value = this.dateFilterEnd;
                    }
                }
            }
            
            return params;
        },
        
        buildSearchUrl(params) {
            const baseUrl = this.searchLevel === 'single' ? '/podkeywordsearch/' : '/mass-search/';
            const queryString = new URLSearchParams();
            
            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    if (Array.isArray(value)) {
                        value.forEach(v => queryString.append(key + '[]', v));
                    } else {
                        queryString.append(key, value);
                    }
                }
            });
            
            return `${baseUrl}?${queryString.toString()}`;
        },
        
        // Keywords Management
        clearKeywords() {
            this.keywords = '';
        },
        
        addAdvancedTerm() {
            if (this.advancedTerms.length < 6) {
                this.advancedTerms.push({ value: '' });
            }
        },
        
        removeAdvancedTerm(index) {
            if (this.advancedTerms.length > 1) {
                this.advancedTerms.splice(index, 1);
            }
        },
        
        clearPodcastSelection() {
            this.selectedPodcasts = [];
        },
        
        clearCategorySelection() {
            this.selectedCategory = [];
        },
        
        clearDateFilter() {
            this.dateFilterMode = 'none';
            this.dateFilterSingle = '';
            this.dateFilterStart = '';
            this.dateFilterEnd = '';
        },
        
        // UI Helpers
        getSearchDescription() {
            const descriptions = {
                single: 'Search through episodes of a specific podcast.',
                multiple: 'Search through episodes of selected podcasts or all podcasts.'
            };
            return descriptions[this.searchLevel] || '';
        },
        
        getKeywordsLabel() {
            const labels = {
                basic: 'Search Keywords',
                advanced: 'Advanced Search Terms',
                episode: 'Episode Title Keywords'
            };
            return labels[this.searchType] || 'Keywords';
        },

        getKeywordsPlaceholder() {
            if (!this.canEnterKeywords()) {
                if (this.searchLevel === 'single') return 'Select a podcast first';
                if (this.searchLevel === 'multiple' && this.searchMode === 'multiple') return 'Select podcasts first';
                if (this.searchLevel === 'multiple' && this.searchMode === 'category') return 'Select categories first';
                return 'Select podcasts first';
            }
            
            const placeholders = {
                basic: 'Enter keywords to search in transcripts...',
                episode: 'Enter episode title keywords...'
            };
            return placeholders[this.searchType] || 'Enter keywords...';
        },
        
        // Search History Management
        loadSearchHistory() {
            try {
            const history = localStorage.getItem('podSearchHistory');
            if (history) {
                this.searchHistory = JSON.parse(history);
                }
            } catch (error) {
                console.error('Error loading search history:', error);
            }
        },

        saveSearchHistory() {
            // Ensure selectedPodcasts is always an array for processing
            let selectedPodcastsArray = [];
            if (Array.isArray(this.selectedPodcasts)) {
                selectedPodcastsArray = this.selectedPodcasts;
            } else if (this.selectedPodcasts && typeof this.selectedPodcasts === 'object') {
                // Single podcast object - convert to array
                selectedPodcastsArray = [this.selectedPodcasts];
            }
            
            const historyItem = {
                timestamp: new Date().toISOString(),
                searchLevel: this.searchLevel,
                searchMode: this.searchLevel === 'multiple' ? this.searchMode : null,
                searchType: this.searchType,
                keywords: this.searchType === 'advanced' ? 
                    this.advancedTerms.filter(t => t.value.trim()).map(t => t.value).join(', ') :
                    this.keywords,
                podcastTitle: this.getHistoryPodcastTitle(),
                podcastIds: selectedPodcastsArray.map(p => p.id),
                categoryId: this.selectedCategory.map(c => c.podcast_category || c).join(','),
                exactMatch: this.exactMatch,
                dateFilterMode: this.dateFilterMode,
                dateFilterSingle: this.dateFilterSingle,
                dateFilterStart: this.dateFilterStart,
                dateFilterEnd: this.dateFilterEnd,
                pinned: false,
                hitCount: null
            };

            this.searchHistory.unshift(historyItem);

            // Keep only recent items (excluding pinned)
            const pinnedItems = this.searchHistory.filter(item => item.pinned);
            const unpinnedItems = this.searchHistory.filter(item => !item.pinned)
                .slice(0, this.maxHistoryItems - pinnedItems.length);
            
            this.searchHistory = [...pinnedItems, ...unpinnedItems];

            try {
            localStorage.setItem('podSearchHistory', JSON.stringify(this.searchHistory));
            } catch (error) {
                console.error('Error saving search history:', error);
            }
        },
        
        updateSearchHistory() {
                try {
                    localStorage.setItem('podSearchHistory', JSON.stringify(this.searchHistory));
                } catch (error) {
                console.error('Error updating search history:', error);
                }
        },

        loadHistoryItem(item) {
            this.searchLevel = item.searchLevel;
            this.searchType = item.searchType;
            this.exactMatch = item.exactMatch;
            
            // Load search mode for multiple/all searches
            if (item.searchLevel === 'multiple' && item.searchMode) {
                this.searchMode = item.searchMode;
            } else if (item.searchLevel === 'multiple') {
                this.searchMode = 'all'; // Default for backward compatibility
            }
            
            if (item.searchType === 'advanced') {
                const terms = item.keywords.split(', ').map(k => ({ value: k.trim() }));
                this.advancedTerms = terms.length > 0 ? terms : [{ value: '' }];
            } else {
                this.keywords = item.keywords;
            }
            
            // Load podcast selection
            if (item.podcastIds && item.podcastIds.length > 0) {
                const selectedPodcasts = this.availablePodcasts.filter(p => 
                    item.podcastIds.includes(p.id)
                );
                
                // Set as single object for single podcast mode, array for multiple
                if (item.searchLevel === 'single') {
                    this.selectedPodcasts = selectedPodcasts[0] || null;
                } else {
                    this.selectedPodcasts = selectedPodcasts;
                }
            }
            
            // Load category selection
            if (item.categoryId) {
                const categoryIds = item.categoryId.split(',');
                this.selectedCategory = this.availableCategories.filter(c => 
                    categoryIds.includes(c.podcast_category) || categoryIds.includes(c)
                );
            }
            
            // Load date filter
            if (item.dateFilterMode) {
                this.dateFilterMode = item.dateFilterMode;
                this.dateFilterSingle = item.dateFilterSingle || '';
                this.dateFilterStart = item.dateFilterStart || '';
                this.dateFilterEnd = item.dateFilterEnd || '';
            } else {
                this.dateFilterMode = 'none';
                this.dateFilterSingle = '';
                this.dateFilterStart = '';
                this.dateFilterEnd = '';
            }
            
            this.showHistory = false;
        },
        
        getHistoryPodcastTitle() {
            if (this.searchLevel === 'multiple' && this.searchMode === 'all') return 'All Podcasts';
            if (this.searchLevel === 'multiple' && this.searchMode === 'category') {
                return this.selectedCategory.length > 0 ? this.selectedCategory.map(c => c.label).join(', ') : 'No Category Selected';
            }
            
            // Handle both array and single object cases
            let selectedPodcastsArray = [];
            if (Array.isArray(this.selectedPodcasts)) {
                selectedPodcastsArray = this.selectedPodcasts;
            } else if (this.selectedPodcasts && typeof this.selectedPodcasts === 'object') {
                selectedPodcastsArray = [this.selectedPodcasts];
            }
            
            if (selectedPodcastsArray.length === 0) return 'No Podcast Selected';
            if (selectedPodcastsArray.length === 1) return selectedPodcastsArray[0].podcast_title;
            return `${selectedPodcastsArray.length} Podcasts`;
        },
        
        getHistoryItemPodcastTitle(item) {
            if (item.searchLevel === 'multiple' && item.searchMode === 'all') return 'All Podcasts';
            if (item.searchLevel === 'multiple' && item.searchMode === 'category') {
                return item.podcastTitle || 'Category Search';
            }
            if (item.podcastTitle) return item.podcastTitle;
            return 'Unknown';
        },
        
        // History Management
        toggleHistory() {
            this.showHistory = !this.showHistory;
        },

        removeHistoryItem(index) {
            this.searchHistory.splice(index, 1);
            this.updateSearchHistory();
        },

        clearHistory() {
            this.searchHistory = [];
            localStorage.removeItem('podSearchHistory');
            this.showHistory = false;
        },

        togglePin(index) {
            this.searchHistory[index].pinned = !this.searchHistory[index].pinned;
            this.searchHistory.sort((a, b) => {
                if (a.pinned && !b.pinned) return -1;
                if (!a.pinned && b.pinned) return 1;
                return new Date(b.timestamp) - new Date(a.timestamp);
            });
            this.updateSearchHistory();
        },

        // Utility Methods
        formatSearchType(type) {
            const types = {
                'basic': 'Basic Search',
                'advanced': 'Advanced Search',
                'episode': 'Episode Search',
                'single': 'Single Podcast',
                'multiple': 'Multiple Podcasts'
            };
            return types[type] || type;
        },
        
        formatHitCount(count) {
            if (count === null || count === undefined) return '';
            if (count === 0) return 'No results';
            if (count === 1) return '1 result';
            return `${count.toLocaleString()} results`;
        },

        formatTime(timestamp) {
            const date = new Date(timestamp);
            const now = new Date();
            const diff = now - date;
            
            if (diff < 24 * 60 * 60 * 1000) {
                const hours = Math.floor(diff / (60 * 60 * 1000));
                if (hours === 0) {
                    const minutes = Math.floor(diff / (60 * 1000));
                    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
                }
                return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
            }
            
            if (diff < 7 * 24 * 60 * 60 * 1000) {
                const days = Math.floor(diff / (24 * 60 * 60 * 1000));
                return `${days} day${days !== 1 ? 's' : ''} ago`;
            }
            
            return date.toLocaleDateString();
        },
        
        formatDateFilter(item) {
            if (!item.dateFilterMode || item.dateFilterMode === 'none') return '';
            
            if (item.dateFilterMode === 'before' && item.dateFilterSingle) {
                return `Before ${this.formatDateDisplay(item.dateFilterSingle)}`;
            } else if (item.dateFilterMode === 'after' && item.dateFilterSingle) {
                return `After ${this.formatDateDisplay(item.dateFilterSingle)}`;
            } else if (item.dateFilterMode === 'between') {
                const start = item.dateFilterStart ? this.formatDateDisplay(item.dateFilterStart) : '';
                const end = item.dateFilterEnd ? this.formatDateDisplay(item.dateFilterEnd) : '';
                if (start && end) {
                    return `${start} - ${end}`;
                } else if (start) {
                    return `After ${start}`;
                } else if (end) {
                    return `Before ${end}`;
                }
            }
            
            return '';
        },
        
        formatDateDisplay(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        },

        // Error Handling
        handleSearchError(error) {
            console.error('Search error:', error);
            
            let message = 'An error occurred while performing the search. ';
            
            if (error.response) {
                switch (error.response.status) {
                    case 404: message = 'Search endpoint not found. Please try again later.'; break;
                    case 403: message = 'You do not have permission to perform this search.'; break;
                    case 429: message = 'Too many search requests. Please wait before trying again.'; break;
                    case 500: message = 'Server error occurred. Please try again later.'; break;
                    default: message += 'Please try again.';
                }
            } else if (error.request) {
                message = 'No response from server. Please check your internet connection.';
            } else {
                message += 'Please try again.';
            }
            
            this.showError(message);
        },
        
        showError(message) {
            this.errorMessage = message;
            setTimeout(() => {
                this.errorMessage = '';
            }, 5000);
        },
        
        // Initialization
        initializeFromProps() {
            if (this.podId) {
                const podcast = this.availablePodcasts.find(p => p.id == this.podId);
                if (podcast) {
                    this.searchLevel = 'single';
                    this.selectedPodcasts = [podcast];
                }
            }
            
            if (this.searchedKeywords) {
                this.keywords = this.searchedKeywords;
            }
        },
        
        updateHitCounts() {
            // Implementation for updating hit counts from current page
            // This would need to be customized based on your backend response
        },
        
        loadSearchStateFromUrl() {
            // Prevent multiple calls
            if (this._urlStateLoaded) return;
            
            // Mark as loading to prevent watchers from resetting state
            this._urlStateLoaded = true;
            
            const urlParams = new URLSearchParams(window.location.search);
            
            // Load search level
            const urlSearchLevel = urlParams.get('slv');
            if (urlSearchLevel && ['single', 'multiple'].includes(urlSearchLevel)) {
                this.searchLevel = urlSearchLevel;
            }
            
            // Load search mode (for multiple)
            const urlSearchMode = urlParams.get('searchMode');
            if (urlSearchMode && ['all', 'multiple', 'category'].includes(urlSearchMode)) {
                this.searchMode = urlSearchMode;
            }
            
            // Load search type
            const urlSearchType = urlParams.get('search_type');
            if (urlSearchType && ['basic', 'advanced', 'episode'].includes(urlSearchType)) {
                this.searchType = urlSearchType;
            }
            
            // Load exact match
            const urlExactMatch = urlParams.get('exact_match');
            if (urlExactMatch !== null) {
                this.exactMatch = urlExactMatch === 'true' || urlExactMatch === '1';
            }
            
            // Load keywords
            const urlKeywords = urlParams.get('keywordsToSearch');
            if (urlKeywords) {
                this.keywords = urlKeywords;
            }
            
            // Load advanced search terms - check URL parameter instead of component state
            const urlSearchTerms = urlParams.get('search_terms');
            const urlSearchTermsArray = urlParams.getAll('search_terms[]');
            
            if (urlSearchType === 'advanced') {
                let terms = [];
                
                // Try array format first (search_terms[])
                if (urlSearchTermsArray && urlSearchTermsArray.length > 0) {
                    terms = urlSearchTermsArray.map(term => ({ value: term.trim() }));
                }
                // Fallback to comma-separated format (search_terms)
                else if (urlSearchTerms) {
                    terms = urlSearchTerms.split(',').map(term => ({ value: term.trim() }));
                }
                
                if (terms.length > 0) {
                    this.advancedTerms = terms;
                }
            }
            
            // Load podcast selection - only if podcasts are available
            const urlPodcastId = urlParams.get('podSelectedId');
            if (urlPodcastId && this.availablePodcasts && this.availablePodcasts.length > 0) {
                const podcastIds = urlPodcastId.split(',').map(id => id.trim());
                const selectedPodcasts = this.availablePodcasts.filter(podcast => 
                    podcastIds.includes(podcast.id.toString())
                );
                
                if (this.searchLevel === 'single') {
                    this.selectedPodcasts = selectedPodcasts[0] || null;
                } else {
                    this.selectedPodcasts = selectedPodcasts;
                }
            }
            
            // Load category selection - only if categories are available
            const urlCategory = urlParams.get('category');
            if (urlCategory && this.availableCategories && this.availableCategories.length > 0) {
                const categoryIds = urlCategory.split(',');
                this.selectedCategory = this.availableCategories.filter(category => 
                    categoryIds.includes(category.podcast_category) || categoryIds.includes(category)
                );
            }
            
            // Load date filter
            const urlDateFilter = urlParams.get('date_filter');
            if (urlDateFilter && ['before', 'after', 'between'].includes(urlDateFilter)) {
                this.dateFilterMode = urlDateFilter;
                
                if (urlDateFilter === 'between') {
                    const urlDateStart = urlParams.get('date_start');
                    const urlDateEnd = urlParams.get('date_end');
                    if (urlDateStart) this.dateFilterStart = urlDateStart;
                    if (urlDateEnd) this.dateFilterEnd = urlDateEnd;
                } else {
                    const urlDateValue = urlParams.get('date_value');
                    if (urlDateValue) this.dateFilterSingle = urlDateValue;
                }
            } else {
                this.dateFilterMode = 'none';
            }
    }
}
};
</script>